/*
 * sw24-herkunft.js — Herkunft fuer Registrierung und Bestellung (Aufgabe #105, 15.10.2026)
 *
 * Was es tut:
 *   1. Merkt sich beim Besuch den ERSTEN und den LETZTEN Kontakt: utm_source/medium/
 *      campaign/content, ob eine Klick-ID da war (gclid/gbraid/wbraid, li_fat_id — nur
 *      ja/nein, nie der Wert), den Referrer-Host und die Einstiegsseite (nur Pfad).
 *   2. Haengt diese Angabe als Feld "herkunft" an die drei Aufrufe an den Pimcore-Server:
 *      /api/b2b/register, /api/b2b/create-invoice-order, /api/b2b/create-draft-order.
 *
 * ⚠️⚠️ NUR mit Zustimmung zur Gruppe "Marketing" (Cookie dt_gdpr_name, siehe
 *   snippets/popup-cookie.liquid und window.CG_CONSENT.parse im <head>). Ohne Zustimmung
 *   wird nichts gespeichert und nichts mitgeschickt; eine fruehere Angabe wird geloescht,
 *   sobald die Zustimmung fehlt. Stimmt der Besucher erst auf der Seite zu, wird der
 *   Kontakt dieser Seite nachgetragen — bis dahin steht er nur im Arbeitsspeicher.
 *
 * Warum ein fetch-Umschlag statt Aenderungen in checkout-gate.js und b2b-registration.js:
 *   beide Dateien werden laufend von anderen Arbeiten angefasst, und die lokalen Kopien
 *   sind gegenueber Live veraltet. Ein Patch per Textersetzung wuerde beim naechsten
 *   Umbau still verloren gehen. Der Umschlag greift nur bei genau diesen drei Adressen,
 *   nur bei POST mit JSON-Text, und faellt bei jedem Fehler auf den unveraenderten
 *   Aufruf zurueck — eine Bestellung haengt nie an diesem Skript.
 *
 * Bewusst NICHT als Warenkorb-Attribut: Warenkorb-Attribute gehen als note_attributes
 *   weiter (checkout-gate.js, b2b-prices.js) und stehen bei nativen Checkouts in der
 *   Bestellmail. Native Checkouts haben ohnehin Shopifys customerJourneySummary.
 */
(function () {
  'use strict';

  var KEY = 'sw24_herkunft';
  var MAX_ALTER_MS = 90 * 24 * 3600 * 1000;
  var ZIELE = ['/api/b2b/register', '/api/b2b/create-invoice-order', '/api/b2b/create-draft-order'];
  var EIGENE = [/(^|\.)myshopify\.com$/, /(^|\.)shopify\.com$/, /(^|\.)shop\.app$/];

  function marketingErlaubt() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)dt_gdpr_name=([^;]*)/);
      if (!m) return false;
      var raw = decodeURIComponent(m[1]);
      if (window.CG_CONSENT && typeof window.CG_CONSENT.parse === 'function') {
        var c = window.CG_CONSENT.parse(raw);
        return !!(c && c.marketing);
      }
      if (raw === 'accepted') return true;
      var x = /^custom:a[01]m([01])$/.exec(raw);
      return !!(x && x[1] === '1');
    } catch (e) { return false; }
  }

  function lesen() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!v || typeof v !== 'object' || !v.erst) return null;
      // Veraltet: der erste Kontakt liegt zu weit zurueck, um noch etwas zu erklaeren.
      if (v.erst.t && Date.now() - v.erst.t > MAX_ALTER_MS) { loeschen(); return null; }
      return v;
    } catch (e) { return null; }
  }

  function schreiben(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }

  function loeschen() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  function eigenerHost(host) {
    var h = String(host || '').replace(/^www\./, '').toLowerCase();
    if (!h) return true;
    if (h === location.hostname.replace(/^www\./, '').toLowerCase()) return true;
    for (var i = 0; i < EIGENE.length; i++) { if (EIGENE[i].test(h)) return true; }
    return false;
  }

  function kurz(v, max) { return v ? String(v).slice(0, max) : ''; }

  // Kontakt dieses Seitenaufrufs. null = kein Signal (interne Navigation, Reload).
  function kontaktDieserSeite() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return null; }
    var refHost = '';
    try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (eigenerHost(refHost)) refHost = '';

    var k = {
      s:  kurz(q.get('utm_source'), 100),
      m:  kurz(q.get('utm_medium'), 100),
      c:  kurz(q.get('utm_campaign'), 150),
      ct: kurz(q.get('utm_content'), 150),
      g:  (q.has('gclid') || q.has('gbraid') || q.has('wbraid')) ? 1 : 0,
      li: q.has('li_fat_id') ? 1 : 0,
      ref: refHost,
      lp: kurz(location.pathname, 300),
      t:  Date.now()
    };
    return (k.s || k.m || k.c || k.g || k.li || k.ref) ? k : null;
  }

  var kontakt = kontaktDieserSeite();

  function festhalten() {
    if (!marketingErlaubt()) { loeschen(); return; }
    var v = lesen();
    if (!v) {
      // Allererster Besuch: auch ohne Signal festhalten — dann ist er "Direkt", und ein
      // spaeterer Werbeklick ueberschreibt nur den LETZTEN Kontakt, nicht den ersten.
      var erst = kontakt || { s: '', m: '', c: '', ct: '', g: 0, li: 0, ref: '', lp: kurz(location.pathname, 300), t: Date.now() };
      schreiben({ v: 1, erst: erst, letzt: erst });
      return;
    }
    if (kontakt) {
      v.letzt = kontakt;
      schreiben(v);
    }
  }

  festhalten();

  // Zustimmung kommt oft erst NACH dem Laden (Banner). CG_CONSENT.update wird vom Banner
  // nach dem Schreiben des Cookies aufgerufen — danach erneut pruefen.
  try {
    if (window.CG_CONSENT && typeof window.CG_CONSENT.update === 'function' && !window.CG_CONSENT.__sw24h) {
      var orig = window.CG_CONSENT.update;
      window.CG_CONSENT.update = function () {
        var r = orig.apply(this, arguments);
        setTimeout(festhalten, 0);
        return r;
      };
      window.CG_CONSENT.__sw24h = true;
    }
  } catch (e) {}

  function zielAdresse(url) {
    for (var i = 0; i < ZIELE.length; i++) { if (url.indexOf(ZIELE[i]) !== -1) return true; }
    return false;
  }

  function fuerServer(v) {
    function k(x) {
      if (!x) return null;
      return { s: x.s, m: x.m, c: x.c, ct: x.ct, g: x.g, li: x.li, ref: x.ref, lp: x.lp, t: x.t };
    }
    return { erst: k(v.erst), letzt: k(v.letzt) };
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function' && !origFetch.__sw24h) {
    var umschlag = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (init && typeof init.body === 'string' && String(init.method || 'GET').toUpperCase() === 'POST'
            && zielAdresse(url) && marketingErlaubt()) {
          var v = lesen();
          if (v) {
            var body = JSON.parse(init.body);
            if (body && typeof body === 'object' && !Array.isArray(body) && body.herkunft === undefined) {
              body.herkunft = fuerServer(v);
              init = Object.assign({}, init, { body: JSON.stringify(body) });
            }
          }
        }
      } catch (e) {}
      return origFetch.call(this, input, init);
    };
    umschlag.__sw24h = true;
    window.fetch = umschlag;
  }
})();
